export default __webpack_public_path__ + "static/media/logo2.c7868c8a.gif";